import { render, staticRenderFns } from "./NumberDeleteModal.vue?vue&type=template&id=04507544"
import script from "./NumberDeleteModal.vue?vue&type=script&lang=js"
export * from "./NumberDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports